<template>
  <v-card>
    <v-card-title class="headline top-title">Ajout d'un projet</v-card-title>
    <v-card-text>
      <v-list>
        <template v-for="item in all">
          <FormLine
            :item="item"
            v-model="instance"
            :key="item.name"
            :edit-mode="true"
          ></FormLine>
          <v-divider :key="`${item.name}-divider`" />
        </template>
      </v-list>
      <v-alert :value="showDuplicateError">
        L'adresse mail existe déjà
      </v-alert>
    </v-card-text>
    <v-card-actions>
      <v-spacer></v-spacer>
      <v-btn flat @click="$emit('close')" color="grey">Annuler</v-btn>
      <v-btn flat @click="addProject()" color="primary" :disabled="loading"
        >Ajouter</v-btn
      >
    </v-card-actions>
    <v-snackbar v-model="showError" :timeout="7000">{{
      errorMessage
    }}</v-snackbar>
  </v-card>
</template>

<script>
import { fetchHil } from "../utils";
import { mapState } from "vuex";
import { getShortInfoFields } from "../data/leaseData";
import FormLine from "./commons/FormLine";
const DEFAULT_VALUES = {
  email: "",
  lastName: "",
  firstName: "",
  phoneNumber: "",
  actualCity: "",
  company: "",
  companyId: null,
  school: "",
  schoolMail: "",
  schoolPhone: "",
  sponsor: "",
  companyMail: "",
  companyPhone: "",
  companyContactName: "",
  contractType: "",
  actualCityObject: null,
  addressWork: "",
  assignees: {
    lead: "",
    sale: ""
  }
};

export default {
  name: "ProjectAdd",
  components: { FormLine },
  props: ["fromAnnouncement"],
  data: function() {
    return {
      instance: { ...DEFAULT_VALUES },
      loading: false,
      showError: false,
      errorMessage: null,
      validWorkAddress: true,
      validActualAddress: true,
      showDuplicateError: false,
      ...getShortInfoFields()
    };
  },
  computed: {
    ...mapState("autocompletes", {
      allStaff: state => state.staff
    }),
    ...mapState("user", ["id"])
  },
  mounted() {
    const [user] = this.allStaff.filter(({ email }) => this.id === email);
    if (user != null) {
      this.instance.assignees.lead = user.trigram;
      this.instance.assignees.sale = user.trigram;
    }
    if (this.fromAnnouncement != null) {
      const [firstName, lastName] = this.fromAnnouncement.contactName.split(
        " ",
        2
      );
      this.instance.email = this.fromAnnouncement.contactEmail;
      this.instance.phoneNumber = this.fromAnnouncement.contactPhoneNumber;
      this.instance.firstName = firstName;
      this.instance.lastName = lastName;
      this.instance.addressWork = this.fromAnnouncement.address;
      this.instance.assignees.lead = this.fromAnnouncement.saleTrigram;
      this.instance.assignees.sale = this.fromAnnouncement.saleTrigram;
    }
  },
  methods: {
    async addProject() {
      if (!(await this.$validator.validate()) || !this.instance.actualCity) {
        return;
      }
      try {
        const {
          email,
          firstName,
          lastName,
          phoneNumber,
          assignees,
          company,
          school,
          schoolMail,
          schoolPhone,
          sponsor,
          actualCity,
          actualCityObject,
          companyMail,
          companyPhone,
          companyContactName,
          contractType,
          addressWork,
          addressWorkObject
        } = this.instance;

        if (company == null) {
          alert("L'entreprise est obligatoire");
          return;
        }
        this.loading = true;
        this.showDuplicateError = false;
        const createResp = await fetchHil(`/customer`, {
          method: "POST",
          body: {
            email: email.toLowerCase(),
            firstName,
            lastName,
            phoneNumber,
            assignees,
            company,
            school,
            sponsor,
            schoolMail,
            schoolPhone,
            companyContactName,
            addressWork,
            fromAddressObject: actualCityObject,
            addressWorkObject,
            actualCity,
            companyMail,
            companyPhone,
            contractType
          }
        });
        this.loading = false;
        if (!createResp.ok) {
          if ((await createResp.json()).message === "duplicateMail") {
            this.showDuplicateError = true;
            return;
          } else {
            throw new Error("resp has failed");
          }
        }
        this.instance = { ...DEFAULT_VALUES };
        this.$emit("added", await createResp.json());
      } catch (err) {
        this.showError = true;
        this.errorMessage = "Une erreur a eu lieu";
      }
    }
  }
};
</script>

<style>
h2 {
  color: grey;
  border-bottom: 1px solid grey;
  margin-bottom: 16px;
  margin-top: 8px;
}

.top-title {
  color: white;
  background: #60a694;
}

.hide-arrow .v-input__icon--append {
  display: none !important;
}
</style>
